import { get, post } from '../api.service';

export interface HolidayRecord {
    id: number,
    amount: number,
    amountToPay: number,
    totalAmountRequested: number,
    taxAmount: number,
    administratorFee: number,
    isActive: boolean,
    status: number,
    paidDate: Date,
    isSalaryCreated: boolean,
    employeeSalarys: boolean,
    employeeSalary: boolean,
    createdDate: Date,
    updatedBy: number | null,
}

export interface HolidayParams {
    PageNumber: number;
    PageSize: number;
    fromDate?: string;
    toDate?: string;
    status?: string;
}

export interface HolidayResponse {
    statusCode: number;
    message: string;
    response: HolidayRecord[];
    totalCount?: number;
    numberOfPages?: number;
}
export interface PayOutResponse {
    statusCode: number,
    message: string,
    response: string,
    totalCount: 0,
    numberOfPages: number
}

export interface HolidayPayResponse {
    statusCode: number,
    message: string,
    response: {
        holidaySavingsAmount: number,
        totalHolidaySavingsAmount: number,
        pensionAmount: number,
        user: {
            userId: number,
            firstName: string,
            lastName: string,
            email: string,
            ssn: number,
            country: string,
            city: string,
            incomeTax: number,
            fakturaFee: number,
            dateOfBirth: number,
            address: string,
            profession: string,
            zipCode: number,
            isActive: boolean
            customCheck: boolean,
            phoneNo: number,
            accountType: number,
            organisation: null,
            fortnoxUserId: number,
            isVerified: boolean,
            isDeleted: boolean,
            socialPlatformId: null,
            createdDate: Date,
            invitedByAmbassador: boolean,
            daysLeft: number,
            invoiceCount: number,
            totalInvoiceAmount: number,
            notes: boolean,
            isSignUptoFortnox: boolean,
            isDetailsUpdatedOnFortnox: boolean,
            isDeactivatedOnFortnox: boolean,
            isBankDetailsUpdatedOnFortnox: boolean,
            isPermanentDeactivate: boolean,
            isBelowEighteen: boolean,
            isParentalEmailReceived: boolean,
            isDeactivateAfter180Days: boolean,
            isUserUploadedToComplyCube: boolean,
            customerSalaryInformation: [],
            invoiceSettings: []
        }
    }
}

/**
 * Fetches holiday pay records with pagination and optional filtering.
 * Corresponds to: GET /api/salarynoticev2/holiday
 * @param params - The request parameters containing PageNumber, PageSize, and optional filters.
 * @returns The API response with holiday pay data.
 */
export const fetchHoliday = async (params: HolidayParams): Promise<HolidayResponse> => {
    try {
        // Build query parameters object
        const queryParams: any = {
            PageNumber: params.PageNumber,
            PageSize: params.PageSize,
        };

        if (params.fromDate) {
            queryParams.fromDate = params.fromDate;
        }
        if (params.toDate) {
            queryParams.toDate = params.toDate;
        }
        if (params.status) {
            queryParams.status = params.status;
        }

        const response = await get('/salarynoticev2/holiday', queryParams);
        return response;
    } catch (error) {
        console.error('Error fetching holiday records:', error);
        throw error;
    }
};

export const payOutHoliday = async (amount: number): Promise<PayOutResponse> => {
    try {

        const response = await post(`/salary/holiday-payout?amount=${amount}` , );
        return response as PayOutResponse;
    } catch (error) {
        console.error('Error fetching holiday records:', error);
        throw error;
    }
};
export const getBalanceHoliday = async (fromDate?: string, toDate?: string): Promise<HolidayPayResponse> => {
    try {
        const params = {
            fromDate,
            toDate,
        }
        const response = await get('/salary/holiday-pension', params);
        return response;
    } catch (error) {
        console.error('Error fetching holiday records:', error);
        throw error;
    }
};